
<div class="grid mg-t-20" *ngIf="activeIndex == 2">
  <div class="col mb-20">
    <div class="grid grid-no-tb-gutter flex justify-content-end align-items-center pr-3">
      <strong></strong>
      <button
      pButton
      tooltipPosition="bottom"   
      *ngIf="!isMobile"
      style="
      background: #F5FAFF; 
      border-color: #FF6C39; 
      border-width: 2px; 
      border-radius: 4px; 
      width: 23px; 
      height: 23px; 
      padding: 0; 
      min-width: unset;
      "
        (click)="showAddInteractionPopup()"
        pTooltip="Add New Interaction">
        <i class="pi pi-plus" style="font-size: 10px;"></i>
        <!-- <span class="pi pi-user-plus mr-2"></span> -->
      </button>
    </div>
  </div>
</div>
<div class="grid">
  <div class="col-12" *ngIf="validInteractionsData">
    <p-accordion class="w-full">
      <p-accordionTab
        (click)="toggleInteraction(index)"
        *ngFor="let interaction of interactionsData; let index = index"
        [selected]="selectedInteraction === index"
      >
        <ng-template pTemplate="header">
          <div class="grid grid-no-tb-gutter">
            <div *ngIf="interaction | interactionIcon" class="col flex-w-auto">
              <img class="v-base" [src]="interaction | interactionIcon" />
              <!-- <i [class]="interaction | interactionIcon"></i> -->
            </div>
            <div class="col">
              <span class="title" [innerHTML]="interaction.summary"></span>
              <span class="date">{{ interaction.interactionDate | date }}</span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <bpc-interaction-details class="accordian-content" [interaction]="interaction"></bpc-interaction-details>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div *ngIf="!validInteractionsData" class="col-12 no-data">
    <!-- class="overview" -->
    <p>No Interaction Data</p>
   <!-- <img src="assets/svg/no-data.gif" alt="No Data" /> -->
  </div>
</div>
